export default __webpack_public_path__ + "static/media/EP23_ERYTHREE.c0e084f5.mp3";